export type DisplayCurrency = 'USD' | 'THB';

export function formatCurrency(value: string | number, currency: DisplayCurrency, digits = 2) {
  return new Intl.NumberFormat(currency === 'THB' ? 'th-TH' : 'en-US', {
    style: 'currency', currency, maximumFractionDigits: digits,
  }).format(Number(value));
}

export function displayMoney(valueUsd: string | number, currency: DisplayCurrency, usdThb: string | number, fractionDigits?: number) {
  const value = Number(valueUsd) * (currency === 'THB' ? Number(usdThb) : 1);
  return new Intl.NumberFormat(currency === 'THB' ? 'th-TH' : 'en-US', {
    style: 'currency', currency, maximumFractionDigits: fractionDigits ?? (currency === 'THB' ? 0 : 2),
  }).format(value);
}

export function compactMoney(valueUsd: string | number, currency: DisplayCurrency, usdThb: string | number) {
  const value = Number(valueUsd) * (currency === 'THB' ? Number(usdThb) : 1);
  return new Intl.NumberFormat(currency === 'THB' ? 'th-TH' : 'en-US', {
    style: 'currency', currency, notation: 'compact', maximumFractionDigits: 1,
  }).format(value);
}

export function formatNumber(value: string | number, digits = 4) {
  return new Intl.NumberFormat('en-US', { maximumFractionDigits: digits }).format(Number(value));
}

export function formatDate(value: string) {
  return new Intl.DateTimeFormat('th-TH', { dateStyle: 'medium', timeStyle: 'short', timeZone: 'Asia/Bangkok' }).format(new Date(value));
}

export function localDateTimeInputValue(date = new Date()) {
  return new Date(date.getTime() - date.getTimezoneOffset() * 60_000).toISOString().slice(0, 16);
}

export const kindLabel: Record<string, string> = {
  TH_EQUITY: 'หุ้นไทย', US_EQUITY: 'หุ้นสหรัฐ', ETF: 'ETF', GOLD: 'ทองคำ', CRYPTO: 'Crypto', FIAT: 'เงินฝาก',
};

export const eventLabel: Record<string, string> = {
  BUY: 'ซื้อ', SELL: 'ขาย', DEPOSIT: 'ฝากเงิน', WITHDRAWAL: 'ถอนเงิน', DIVIDEND: 'ปันผล',
  INTEREST: 'ดอกเบี้ย', FEE: 'ค่าธรรมเนียม', TAX: 'ภาษี', FX_EXCHANGE: 'แลกเงิน', TRANSFER: 'โอน',
  SPLIT: 'แตกพาร์', ADJUSTMENT: 'ปรับยอด', OPENING_BALANCE: 'ยอดตั้งต้น',
};
